import React, { createRef, useEffect, useRef, useState } from "react";
import { NavLink, useLocation, useParams } from "react-router-dom";
import axios from "axios";
import "./LivePage.css";
import { useNavigate } from "react-router";
import {
	Select,
	AutocompleteItem,
	Autocomplete,
	Chip,
	Pagination,
	SelectItem,
	Button,
	Accordion,
	AccordionItem,
	CardHeader,
	CardBody,
	Card,
	Popover,
	PopoverTrigger,
	PopoverContent,
	Listbox,
	ListboxItem,
} from "@heroui/react";
import UserChip from "../components/UserChip";
import { CheckIcon } from "./ChatPage";
import HoverMedals from "../components/HoverMedals";
import { LiveMessageChart } from "../components/LineChart";
import { OnlineChartModal, OnlineChart } from "../components/OnlineChart";
import { eventBus } from "../App";
import { parseMessage } from "../components/ChatArea";
import ActionTable from "../components/ActionTable2";
import { useUpdateEffect } from "react-use";
import MActions from "../components/MActions";

function PlayIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			class="icon"
			viewBox="0 0 24 24"
			width="24"
			height="24"
		>
			<path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" />
			<path d="M719.4 499.1l-296.1-215A15.9 15.9 0 0 0 398 297v430c0 13.1 14.8 20.5 25.3 12.9l296.1-215a15.9 15.9 0 0 0 0-25.8zm-257.6 134V390.9L628.5 512 461.8 633.1z" />
		</svg>
	);
}
const COLORS = {
	green: { bg: "bg-green-50", hover: "hover:bg-green-100" },
	yellow: { bg: "bg-yellow-50", hover: "hover:bg-yellow-100" },
	pink: { bg: "bg-pink-50", hover: "hover:bg-pink-100" },
	blue: { bg: "bg-blue-50", hover: "hover:bg-blue-100" },
};

function Stat({ label, value, color, onClick, small }) {
	const c = COLORS[color] || {};
	return (
		<div
			onClick={onClick}
			className={`rounded-xl ${c.bg} dark:bg-[#18181b] dark:hover:bg-[#232326] p-2 transition-colors duration-150 ${
				onClick ? `cursor-pointer ${c.hover}` : ""
			}`}
		>
			{label}
			<br />
			<span
				className={`font-semibold ${small ? "text-xs leading-tight" : ""}`}
			>
				{value}
			</span>
		</div>
	);
}
function FilterIcon({ className }) {
	return (
		<svg
			className={className}
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
		</svg>
	);
}
function ResponsiveFilterWrapper({ children }) {
	if (isMobile()) {
		return (
			<Accordion className="px-0 w-full" variant="light">
				<AccordionItem
					key="filters"
					classNames={{
						base: "w-full",
						title: "text-[14px] text-gray-500 font-medium",
						content: "px-3 pb-3 pt-0",
						trigger: "py-2 px-3",
					}}
					title={
						<div className="flex items-center gap-2">
							<FilterIcon className="w-4 h-4 text-gray-400" />
							<span className="text-[14px] text-gray-500">
								展开筛选
							</span>
						</div>
					}
				>
					{children}
				</AccordionItem>
			</Accordion>
		);
	}
	return <>{children}</>;
}

function LiveDetailPage(props) {
	let { id } = useParams();
	const { search } = useLocation();
	const params = new URLSearchParams(search);
	const [mid, setMid] = useState(0);

	const p = parseInt(params.get("page"));
	const [currentPage, setCurrentPage] = useState(isNaN(p) ? 1 : p);

	const [pageSize, setPageSize] = useState(
		localStorage.getItem("defaultPageSize"),
	);
	const [dataSource, setDatasource] = useState([]);

	const [total, setTotal] = useState(0);

	const [order, setOrder] = useState("time");
	const [filters, setFilters] = useState([]);

	const [showMinuteChart, setShowMinuteChart] = useState(false);
	const [liveInfo, setLiveInfo] = useState({});
	const [msgData, setMsgData] = useState([]);
	const [user, setUser] = useState([]);
	const [filter, setFilter] = useState("");
	const [playBack, setPlayBack] = useState([]);

	const ROOM_ID = useRef();

	const cardRef = useRef();
	const refreshData = (page0, size, name, filter0) => {
		var page = parseInt(page0);

		if (!window.LIVE_MSG_CACHE) {
			window.LIVE_MSG_CACHE = [];
		}

		const handleResponse = (obj) => {
			(obj.items ?? []).forEach((item, index) => {
				if (item.gift_name) {
					obj.items[index].extra = item.gift_name;
				}
				delete obj.items[index].liver_name;
				delete obj.items[index].liver_id;
				obj.items[index].CreatedAt = new Date(
					obj.items[index].created_at,
				).toLocaleString();
			});
			setTotal(parseInt(obj.total));
			if (obj.items.length >= 200) {
				setDatasource(obj.items.slice(0, 100));
				clearTimeout(window.__actionTableTimer);
				window.__actionTableTimer = setTimeout(() => {
					setDatasource(obj.items);
				}, 100);
			} else {
				setDatasource(obj.items ?? []);
			}
		};
		if (page === undefined) {
			return;
		}

		var url = `/api/actions?live=${id}&pn=${page}&ps=${size}&order=${order !== "" ? order : "time"}&uid=${mid}&pb=1&room=${ROOM_ID.current}`;
		if (name != null) {
			url = url + `&name=${name}`;
		}
		if (filter0 || filter) {
			url = url + `&type=${filter || filter0}`;
		}
		if (window.LIVE_MSG_CACHE[page]) {
			handleResponse(window.LIVE_MSG_CACHE[page]);
		} else {
			axios.get(url).then((res) => {
				handleResponse(res.data);
			});
		}
	};
	useEffect(() => {
		axios.get(`/api/live/user?live=${id}`).then((res) => {
			setUser(res.data.list);
		});
		axios.get(`/api/live/info?id=${id}`).then((res) => {
			setLiveInfo(res.data.live);
			ROOM_ID.current = res.data.live.RoomId;
			refreshData(currentPage, pageSize, null, filter);
			document.title =
				"Vtuber 数据 - " +
				res.data.live.UserName +
				"  -  " +
				res.data.live.Title;
		});

		window.LIVE_MSG_CACHE = [];

		/*	axios.get("/api/playback?id=" + id).then((res) => {
			setPlayBack(res.data.files ?? []);
		});*/

		if (params.get("highLight") !== "") {
			const sleep = (ms) =>
				new Promise((resolve) => setTimeout(resolve, ms));
			async function highlight() {
				for (let i = 0; i < 30; i++) {
					await sleep(100);
					var target = document.getElementById(
						params.get("highLight"),
					);
					if (target) {
						target.scrollIntoView({
							behavior: "smooth",
							block: "center",
						});
						break;
					}
				}
			}
			highlight();
		}
	}, []);

	useEffect(() => {}, [filter, mid, pageSize]);

	useUpdateEffect(() => {
		const handler = () => {
			refreshData(currentPage, pageSize, null, filter);
		};
		handler();
		eventBus.on("refresh", handler);
		return () => {
			eventBus.off("refresh", handler);
		};
	}, [currentPage, pageSize, filter, mid, order]);

	function formatTimeDiff(startTimestamp, endTimestamp) {
		const diffMs = Math.abs(endTimestamp - startTimestamp); // 毫秒差
		const diffMinutes = Math.floor(diffMs / 1000 / 60);

		if (diffMinutes <= 60) {
			return `${diffMinutes} 分钟`;
		} else {
			const diffHours = (diffMinutes / 60).toFixed(1); // 保留 1 位小数
			return `${diffHours} 小时`;
		}
	}

	const [showOnline, setShowOnline] = useState(false);

	const [showPlayBack, setShowPlayBack] = useState(false);

	const renderFilters = (mobile = false) => {
		const orderSelect = (
			<Select
				isClearable
				onClear={() => setOrder("")}
				className={
					mobile
						? "w-full"
						: "max-w-xs sm:max-w-1/4 mt-4 mb-4 sm:ml-4 ml-0"
				}
				size={mobile ? "sm" : "md"}
				items={[
					{
						key: "gift_price_desc",
						value: "￥",
					},
					{
						key: "time",
						value: "时间正序",
					},
					{
						key: "time_desc",
						value: "时间倒序",
					},
				]}
				label="排序"
				selectedKeys={order ? [order] : []}
				onSelectionChange={(e) => {
					setOrder(e.currentKey);
					setCurrentPage(1);
				}}
			>
				{(f) => <SelectItem key={f.key}>{f.value}</SelectItem>}
			</Select>
		);

		const filterSelect = (
			<Select
				isClearable
				className={
					mobile
						? "w-full"
						: "max-w-xs sm:max-w-1/4 mt-4 mb-4 md:ml-4"
				}
				size={mobile ? "sm" : "md"}
				items={[
					{
						key: "1",
						value: "弹幕",
					},
					{
						key: "2",
						value: "礼物",
					},
					{
						key: "3",
						value: "大航海",
					},
					{
						key: "4",
						value: "SuperChat",
					},
					{
						key: "9",
						value: "红包",
					},
					/*			{
						key: "10",
						value: "红包中奖",
					},*/
				]}
				label="筛选"
				selectedKeys={filter ? [filter] : []}
				onSelectionChange={(e) => {
					setCurrentPage(1);
					setFilter(e.currentKey);
				}}
			>
				{(f) => <SelectItem key={f.key}>{f.value}</SelectItem>}
			</Select>
		);

		const watcherAutocomplete = (
			<Autocomplete
				isClearable
				setUser={() => setOrder("")}
				className={
					mobile
						? "w-full"
						: "max-w-xs sm:max-w-1/4 mt-4 mb-4 md:ml-4"
				}
				size={mobile ? "sm" : "md"}
				items={user}
				label="Watcher"
				onSelectionChange={(e) => {
					setCurrentPage(1);
					setMid(e);
				}}
				onInputChange={(e) => {
					var url = `/api/live/user?live=${id}&keyword=${e}`;
					axios.get(url).then((response) => {
						setUser(response.data.list);
					});
				}}
			>
				{(f) => (
					<AutocompleteItem key={f.FromId} textValue={f.FromName}>
						<UserChip props={f}></UserChip>
					</AutocompleteItem>
				)}
			</Autocomplete>
		);

		if (mobile) {
			return (
				<div className="flex flex-col gap-2 w-full">
					<div className="grid grid-cols-2 gap-2 w-full">
						{orderSelect}
						{filterSelect}
					</div>
					{watcherAutocomplete}
				</div>
			);
		}

		return (
			<>
				{orderSelect}
				{filterSelect}
				{watcherAutocomplete}
			</>
		);
	};

	return (
		<div
			className={
				"flex justify-center flex-col w-full mx-auto  min-[2048px]:w-[90vw] "
			}
		>
			<div className={"flex flex-col sm:flex-row"}>
				{!!showOnline && (
					<OnlineChartModal
						id={id}
						onClose={() => {
							setShowOnline(false);
						}}
					/>
				)}
				{
					<LiveMessageChart
						data={msgData}
						live={liveInfo}
						onClose={() => {
							setShowMinuteChart(false);
						}}
						isOpen={showMinuteChart}
						id={id}
					/>
				}
				{/*	{!!(liveInfo && liveInfo.EndAt && liveInfo.EndAt !== 0) && (
				<PlayBackForm items={playBack} id={id} />
			)}*/}
				<div className="top-0 sm:top-12 h-auto sm:h-[96vh] mt-0 sm:mt-2 sticky  sm:w-[35vw] 2xl:w-[28vw] min-[2048px]:w-[35vw]  w-full mr-0 sm:mr-4 rounded-2xl bg-white dark:bg-zinc-950 p-5 shadow-sm border border-zinc-100 dark:border-zinc-900 overflow-scroll scrollbar-hide space-y-4">
					<div className="flex items-center justify-between gap-3">
						<NavLink
							to={`/liver/${liveInfo.UserID}`}
							className="flex items-center gap-3 min-w-0"
						>
							<img
								src={`${AVATAR_API}${liveInfo.UserID}`}
								className="w-11 h-11 rounded-full shrink-0"
							/>
							<span className="font-bold text-zinc-900 dark:text-zinc-100 truncate">
								{liveInfo.UserName}
							</span>
						</NavLink>

						<div className="flex items-center gap-2 shrink-0">
							<Chip
								className="text-xs px-3 py-1.5  font-medium"
								variant={"flat"}
							>
								<span className={"mr-1"}>{liveInfo.Area}</span>

								<span>
									{liveInfo.Encoder?.includes("bilibili/") &&
										"  |  " +
											liveInfo.Encoder.split("/")[0]}
								</span>
							</Chip>
						</div>
					</div>

					<h2 className="text-lg font-bold text-zinc-900 dark:text-zinc-100 leading-snug">
						{liveInfo.Title}
					</h2>

					<div className="grid gird-cols-1 sm:grid-cols-1 gap-3 text-sm">
						<Stat
							label="开始时间"
							value={new Date(
								liveInfo.StartAt * 1000 - 8 * 3600 * 1000,
							).toLocaleString()}
							color="slate"
						/>
						<Stat
							label="结束时间"
							value={new Date(
								liveInfo.EndAt * 1000,
							).toLocaleString()}
							color="slate"
						/>
						<Stat
							label="时长"
							value={formatTimeDiff(
								liveInfo.StartAt * 1000 - 8 * 3600 * 1000,
								liveInfo.EndAt * 1000 || new Date().getTime(),
							)}
							color="slate"
						/>
					</div>

					<div className="grid gird-cols-1 sm:grid-cols-1  gap-3 text-sm">
						<Stat
							label="观众数"
							value={liveInfo.Watch}
							color="green"
							onClick={() => setShowOnline(true)}
						/>
						<Stat
							label="弹幕数"
							value={liveInfo.Message}
							color="yellow"
							onClick={() => {
								axios
									.get("/api/live/chart/msg?id=" + id)
									.then((res) => {
										setMsgData(res.data.data);
										setShowMinuteChart(true);
									});
							}}
						/>
						<Stat
							label="流水"
							value={formatFloat(liveInfo.Money)}
							color="slate"
						/>
					</div>
					{!isMobile() && <OnlineChart id={id}></OnlineChart>}
				</div>

				<div
					className={"sm:w-[65vw] w-full ml-0 sm:ml-8 relative z-10"}
				>
					{!isMobile() && (
						<div className="flex flex-wrap items-center">
							{renderFilters(false)}
						</div>
					)}
					{isMobile() ? (
						<Card
							className={
								"h-[80vh] relative z-10 shadow-lg bg-white dark:bg-zinc-950"
							}
						>
							<CardHeader className="p-0 border-b border-zinc-100 dark:border-zinc-800 flex flex-col items-stretch">
								<ResponsiveFilterWrapper>
									{renderFilters(true)}
								</ResponsiveFilterWrapper>
							</CardHeader>
							<CardBody ref={cardRef}>
								{dataSource.map((item, index) => (
									<MActions
										item={item}
										key={item.id}
										highLight={
											item.id === params.get("highLight")
										}
									/>
								))}
							</CardBody>
						</Card>
					) : (
						<ActionTable
							initialPage={isNaN(p) ? 1 : p}
							highLight={params.get("highLight")}
							dataSource={dataSource}
							total={total}
							handlePageChange={(page0) => {
								setCurrentPage(page0);
								refreshData(page0, pageSize, null);
								if (page >= 2) {
									window.USER_PAGE = page0;
								}
								window.scrollTo({
									top: 0,
									behavior: "smooth",
								});
							}}
							disableLocate
							ref={cardRef}
						></ActionTable>
					)}
				</div>

				{isMobile() && (
					<div className="w-full flex justify-center my-3 relative z-10">
						<Pagination
							isCompact
							showControls
							showShadow
							color="secondary"
							page={currentPage}
							total={Math.ceil(total / pageSize)}
							onChange={(page) => {
								setCurrentPage(page);
								cardRef.current.scrollTo({
									top: 0,
									behavior: "smooth",
								});
							}}
						/>
					</div>
				)}
			</div>
		</div>
	);
}

export default LiveDetailPage;
